import { AnimatePresence } from 'framer-motion';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import React from 'react';
import HomePage from '../pages/HomePage';
import Profile from '../pages/Profile';
import OrderPage from '../pages/OrderPage';
import JoinPage from '../pages/JoinPage';
import AuthPage from '../pages/auth/auth_page';
import SettingsPage from '../pages/settings/SettingsPage';
import PageTransition from './common/PageTransition';
import ProtectedRoute from './common/ProtectedRoute';
import { useAuth } from '../context/AuthContext';

const AnimatedRoutes = () => {
  const location = useLocation();
  const { user } = useAuth();

  return (
    <AnimatePresence mode="wait" initial={false}>
      <Routes location={location} key={location.pathname}>
        <Route 
          path="/" 
          element={
            <ProtectedRoute requireAuth={true}>
              <PageTransition transition="home">
                <HomePage />
              </PageTransition>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/order" 
          element={
            <ProtectedRoute requireAuth={true}>
              <PageTransition transition="order">
                <OrderPage />
              </PageTransition>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/Profile" 
          element={
            <ProtectedRoute requireAuth={true}>
              <PageTransition transition="profile">
                <Profile/>
              </PageTransition>
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/join" 
          element={
            <ProtectedRoute requireAuth={true}>
              <PageTransition transition="join">
                <JoinPage />
              </PageTransition>
            </ProtectedRoute>
          } 
        />
        <Route
          path="/auth"
          element={
            <ProtectedRoute requireAuth={false}>
              <PageTransition transition="fade">
                <AuthPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute requireAuth={true}>
              <PageTransition transition="settings">
                <SettingsPage />
              </PageTransition>
            </ProtectedRoute>
          }
        />
        {/* Catch all route */}
        <Route 
          path="*" 
          element={<Navigate to="/" replace />} 
        />
        {/* Catch all route to redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
